// Content Accordion functionality
const contentAccordions = document.querySelectorAll('.block-accordion-content');

contentAccordions.forEach(accordion => {
    const accordionItems = accordion.querySelectorAll('.accordion-item');

    accordionItems.forEach(item => {
        const question = item.querySelector('.accordion-question');
        const answer = item.querySelector('.accordion-answer');

        if (question && answer) {
            // Add click event listener to the question area only
            question.addEventListener('click', function() {
                toggleAccordionItem(item);
            });

            // Prevent clicks on answer area from closing the accordion
            answer.addEventListener('click', function(e) {
                e.stopPropagation();
            });

            // Add keyboard support
            item.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleAccordionItem(item);
                }
            });
        }
    });
});

function toggleAccordionItem(item) {
    const question = item.querySelector('.accordion-question');
    const answer = item.querySelector('.accordion-answer');
    const isActive = item.classList.contains('is-active');
    const accordionBlock = item.closest('.block-accordion-content');
    const multiOpen = accordionBlock.getAttribute('data-multi-open') === 'true';

    if (isActive) {
        // Close the accordion item
        item.classList.remove('is-active');
        question.setAttribute('aria-expanded', 'false');
        answer.style.display = 'none';
    } else {
        // Only close other items if multi-open is disabled
        if (!multiOpen) {
            const allItems = accordionBlock.querySelectorAll('.accordion-item');

            allItems.forEach(otherItem => {
                if (otherItem !== item) {
                    const otherQuestion = otherItem.querySelector('.accordion-question');
                    const otherAnswer = otherItem.querySelector('.accordion-answer');
                    otherItem.classList.remove('is-active');
                    otherQuestion.setAttribute('aria-expanded', 'false');
                    otherAnswer.style.display = 'none';
                }
            });
        }

        // Open the clicked accordion item
        item.classList.add('is-active');
        question.setAttribute('aria-expanded', 'true');
        answer.style.display = 'block';
    }
}
